export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tipo di indirizzo"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tipo di conto"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Valuta"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nome"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crea indirizzo"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crea conto"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Creazione di un nuovo indirizzo"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crea nuovo conto"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inserisci il nome"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seleziona la valuta"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crea"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annulla"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seleziona il tipo"])}
}